import {
	type IGetVolunteerStatusResponse,
	type IVolunteerByIdResponse,
	type IVolunteerEDStats,
	type IVolunteerResponse,
	type IVolunteerStatsResponse,
} from '../../../interface/state/IVolunteer';
import { volunteerType } from '../../types';
import { getCommandQuery, type IGetQuery, type IResponse } from '../api-utils';
import * as utils from '../utils';

export const create_Volunteer = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: {
		firstName: string;
		lastName: string;
		email: string;
		phoneNumber: string;
	};
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/Volunteer',
			header: utils.header(),
			data,
		},
		actionType: volunteerType.create_Volunteer,
		onFailure,
		onSuccess,
		auth: true,
	});

export const get_Volunteer = ({ onFailure, onSuccess, query, paged }: IGetQuery<IVolunteerResponse>) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/Volunteer${getCommandQuery(paged, ...(query || []))}`,
			header: utils.header(),
		},
		actionType: volunteerType.get_Volunteer,
		onFailure,
		onSuccess,
	});

export const get_VolunteerRightSection = ({ onFailure, onSuccess, query, paged }: IGetQuery<IVolunteerResponse>) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/Volunteer${getCommandQuery(paged, ...(query || []))}`,
			header: utils.header(),
		},
		actionType: volunteerType.get_VolunteerRightSection,
		onFailure,
		onSuccess,
	});

export const get_VolunteerByID = ({ onFailure, onSuccess, id }: IResponse<IVolunteerByIdResponse> & { id: string }) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/Volunteer/${id}`,
			header: utils.header(),
		},
		actionType: volunteerType.get_VolunteerByID,
		onFailure,
		onSuccess,
	});

/** `GET Volunteer/approve/{id}` — `?confirmTrust=false` only when the admin unticked the confirm box. */
export const approveVolunteerUrl = (id: string | number, confirmTrust?: boolean) =>
	`/api/v1/Volunteer/approve/${id}${confirmTrust === false ? '?confirmTrust=false' : ''}`;

export const approve_Volunteer = ({
	onFailure,
	onSuccess,
	id,
	confirmTrust,
}: IResponse & { id: string; confirmTrust?: boolean }) =>
	utils.httpGetMethod({
		apiData: {
			// The server defaults `confirmTrust` to true, so only the opt-out travels.
			url: approveVolunteerUrl(id, confirmTrust),
			header: utils.header(),
		},
		actionType: volunteerType.approve_Volunteer,
		onFailure,
		onSuccess,
	});

export const reject_Volunteer = ({
	onFailure,
	onSuccess,
	id,
	data,
}: IResponse & { id: string; data: { volunteerStatusId: number } }) =>
	utils.httpPutMethod({
		apiData: {
			url: `/api/v1/Volunteer/update-status/${id}`,
			header: utils.header(),
			data,
		},
		actionType: volunteerType.reject_Volunteer,
		onFailure,
		onSuccess,
	});

export const delete_Volunteer = ({ onFailure, onSuccess, id }: IResponse & { id: string }) =>
	utils.httpDeleteMethod({
		apiData: {
			url: `/api/v1/Volunteer/delete/${id}`,
			header: utils.header(),
		},
		actionType: volunteerType.delete_Volunteer,
		onFailure,
		onSuccess,
	});

// status
export const create_VolunteerStatus = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: {
		name: string;
	};
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/VolunteerStatus',
			header: utils.header(),
			data,
		},
		actionType: volunteerType.create_VolunteerStatus,
		onFailure,
		onSuccess,
		auth: true,
	});

export const get_VolunteerDashboardData = ({ onFailure, onSuccess, query, paged }: IGetQuery<IVolunteerStatsResponse>) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/Volunteer/get-dashboard-data${getCommandQuery(paged, ...(query || []))}`,
			header: utils.header(),
		},
		actionType: volunteerType.get_VolunteerDashboardData,
		onFailure,
		onSuccess,
	});

export const get_VolunteerStatus = ({ onFailure, onSuccess, paged, query }: IGetQuery<IGetVolunteerStatusResponse[]>) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/VolunteerStatus${getCommandQuery(paged, ...(query || []))}`,
			header: utils.header(),
		},
		actionType: volunteerType.get_VolunteerStatus,
		onFailure,
		onSuccess,
	});

export const get_VolunteerStatusById = ({ onFailure, onSuccess, id }: IResponse<IGetVolunteerStatusResponse> & { id: string }) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/VolunteerStatus/${id}`,
			header: utils.header(),
		},
		actionType: volunteerType.get_VolunteerStatusById,
		onFailure,
		onSuccess,
	});

export const get_VolunteerStats = ({
	onFailure,
	onSuccess,
	partyId,
	electionId,
}: IResponse<IVolunteerEDStats> & { partyId: string; electionId: string }) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/Volunteer/get-dashboard-data?electionId=${electionId}&partyId=${partyId}`,
			header: utils.header(),
		},
		actionType: volunteerType.get_VolunteerStats,
		onFailure,
		onSuccess,
	});

export const update_VolunteerStatusById = ({ onFailure, onSuccess, id }: IResponse<any> & { id: string }) =>
	utils.httpPutMethod({
		apiData: {
			url: `/api/v1/VolunteerStatus/${id}`,
			header: utils.header(),
		},
		actionType: volunteerType.get_VolunteerStatusById,
		onFailure,
		onSuccess,
	});
